<template>
  <div class="container">
    
<FormKitLazyProvider>
<h1>Kiosk</h1>

    <FormKit
      type="form"
      :actions="false"
      :value="{ kiosk: kiosk }"
      @submit="save"
    >
      <FormKit
        type="select"
        name="kiosk"
        :placeholder="$t('Select store')"
        :options="stores"
      />

      <button
        type="submit"
        class=" button button--cta"
      >
        <span>Opslaan</span>
      </button>
    </FormKit>
</FormKitLazyProvider>

  </div>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const { stores, kiosk, setKiosk } = useKiosk()

const save = (data: { kiosk: string }) => {
  setKiosk(data.kiosk)
}
</script>
